import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout, isSiteAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/"); // Optional: redirect to home after logout
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  return (
    <nav className="bg-white shadow-md px-4 py-3 flex items-center justify-between sticky top-0 z-50">
      <Link to="/" className="text-xl font-bold text-pink-600">
        🎉 Festigram
      </Link>

      {/* Mobile Hamburger */}
      <div className="md:hidden">
        <button onClick={() => setMenuOpen(!menuOpen)} className="text-2xl">
          ☰
        </button>
      </div>

      {/* Desktop Links */}
      <div className="hidden md:flex space-x-4 items-center">
        {user ? (
          <>
            <Link
              to="/admin/setup"
              className="hover:underline text-sm font-medium"
            >
              Event Setup
            </Link>
            {isSiteAdmin && (
              <Link
                to="/manager"
                className="hover:underline text-sm font-medium"
              >
                Manager
              </Link>
            )}
            <button
              onClick={handleLogout}
              className="text-sm font-medium text-gray-600 hover:text-pink-600"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="hover:underline text-sm font-medium">
              Login
            </Link>
            <Link
              to="/register"
              className="hover:underline text-sm font-medium"
            >
              Register
            </Link>
          </>
        )}
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="absolute top-16 left-0 right-0 bg-white shadow-md p-4 flex flex-col items-start md:hidden space-y-2">
          {user ? (
            <>
              <Link
                to="/admin/setup"
                onClick={() => setMenuOpen(false)}
                className="hover:underline text-sm font-medium"
              >
                Event Setup
              </Link>
              {isSiteAdmin && (
                <Link
                  to="/manager"
                  onClick={() => setMenuOpen(false)}
                  className="hover:underline text-sm font-medium"
                >
                  Manager
                </Link>
              )}
              <button
                onClick={() => {
                  setMenuOpen(false);
                  handleLogout();
                }}
                className="text-sm font-medium text-gray-600 hover:text-pink-600"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                onClick={() => setMenuOpen(false)}
                className="hover:underline text-sm font-medium"
              >
                Login
              </Link>
              <Link
                to="/register"
                onClick={() => setMenuOpen(false)}
                className="hover:underline text-sm font-medium"
              >
                Register
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
